import { Box } from "@mui/material";
import React, { useReducer } from "react";
import { Outlet } from "react-router-dom";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
const DesktopLayout = (props) => {
    const { scrollRef } = props;
    const [drawerOpen, toggleDrawer] = useReducer((prev) => !prev, false);
    return (React.createElement(React.Fragment, null,
        React.createElement(SiteHeader, { menuOpen: drawerOpen, onMenuToggle: toggleDrawer, hideMobileNav: true }),
        React.createElement(Box, { sx: {
                flex: 1,
                minHeight: 0,
                width: "100%",
                display: "flex",
                flexDirection: "column",
            } },
            React.createElement(Box, { ref: scrollRef, sx: {
                    flex: 1,
                    width: "100%",
                } },
                React.createElement(Outlet, null))),
        React.createElement(SiteFooter, null)));
};
export default DesktopLayout;
